import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 76px;
    height: 76px;

    @media ${breakpoint.s} {
      width: 76px;
      height: 76px;
    }
  }
`

const EmptyIcon = () => {
  return (
    <IconContainer>
      <svg viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='64' height='64' fill='#F3F3F5' />
        <path
          d='M38.8296 54.882V24.7665C38.8296 20.7534 34.3645 19.6039 34.3645 18.1849C34.3645 16.766 34.3645 11.2052 34.3645 11.2052C34.7856 11.0173 34.7068 10.1614 34.7068 10.1614L34.496 8.1016C34.4432 6.87063 32.4164 7.00425 32.4164 7.00425C32.4164 7.00425 30.389 6.87063 30.3369 8.1016L30.1261 10.1614C30.1261 10.1614 30.0473 11.0173 30.4684 11.2052C30.4684 11.2052 30.4684 16.7864 30.4684 18.1849C30.4684 19.5835 26.0026 20.7527 26.0026 24.7658V54.882C26.0026 54.882 25.673 58 32.4164 58C39.1593 58 38.8296 54.882 38.8296 54.882Z'
          fill='#D0D0D6'
        />
      </svg>
    </IconContainer>
  )
}

export default EmptyIcon
